import axios from 'axios';
import { commonConfiguration } from 'io/API';
import { onRequestError } from 'io/API/errorHandling';
import { getCookie } from 'utils/cookies';

const getCSRFToken = () => {
	const match = document.cookie.match(/csrftoken=([^;]+)/);
	return match && match[1] ? match[1] : null;
};

const postUser = (changes, contextConfiguration) => {
	const csrfToken = getCSRFToken();

	const token = getCookie('authToken');
	return axios.post(
		'/user',
		changes,
		{
			...commonConfiguration,
			...contextConfiguration,
			withCredentials: true,
			headers: {
				'X-CSRFToken': csrfToken,
				Authorization: token ? `Token ${token}` : undefined,
				'X-Requested-With': 'XMLHttpRequest',
			},
		}
	).catch(onRequestError);
};

export default postUser;
